import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberAcademicDegree } from "./routeType";

const { key, getPath } = getApi("members.academicDegree.getAll");

type IExtractedRouteType =
  IMemberAcademicDegree["memberAcademicDegreeCollectionRetrieve"];

export type IGetAllMemberAcademicGroups =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberAcademicGroups: Fetcher<
  IGetAllMemberAcademicGroups["response"],
  IGetAllMemberAcademicGroups["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetAllMemberAcademicGroups = createQuery({
  queryKey: [key],
  fetcher: getAllMemberAcademicGroups,
});
